import classes from "./ZirvuFileManagerInput.module.css";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";
import ZirvuFileManagerInputItem from "./ZirvuFileManagerInputItem";
import { get, getOne, post, del } from "./ZirvuFileManagerAPIRequest";
import { ProgressSpinner } from "primereact/progressspinner";
import { FileUpload } from "primereact/fileupload";
import { ContextMenu } from "primereact/contextmenu";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ZirvuFileManagerDialogInputText from "./ZirvuFileManagerDialogInputText";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import useIsMobile from "../../hooks/useIsMobile";
import UiContext from "../../store/ui-context";

const ZirvuFileManagerInput = (props) => {
  const cm = useRef(null);
  const fileUploadRef = useRef(null);
  const dialogInputTextRef = useRef(null);
  const isMobile = useIsMobile();
  const uiContext = useContext(UiContext);

  const [value, setValue] = useState(props.value);

  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogInputTextNewFolderVisible, setDialogInputTextNewFolderVisible] =
    useState(false);
  const [dialogInputTextRenameVisible, setDialogInputTextRenameVisible] =
    useState(false);
  const [listItemSource, setListItemSource] = useState([]);
  const [listItem, setListItem] = useState([]);

  const [clipboard, setClipboard] = useState({ type: "", id: -1, name: "" });
  const [loading, setLoading] = useState(false);
  const [folderId, setFolderId] = useState(-1);
  const [currentPath, setCurrentPath] = useState("");
  const [backFolderId, setBackFolderId] = useState(-1);
  const [order, setOrder] = useState("");
  const [orderMethod, setOrderMethod] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(-1);
  const [selectedType, setSelectedType] = useState("");
  const [selectedElement, setSelectedElement] = useState({});
  const [showDropableEffect, setShowDropableEffect] = useState(false);
  // const [dialogContentType, setDialogContentType] = useState(""); // '', 'explorer', 'dropable-notif', 'file-on-top'

  const tokenFileManager = useSelector((state) => state.auth.tokenFileManager);

  // hidden camera input ref, used when props.directPhoto is set
  const cameraInputRef = useRef(null);

  useEffect(() => {
    if (dialogVisible) {
      loadFolder({ token: tokenFileManager, folderIdFilter: folderId });
    }
  }, [dialogVisible]);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const loadFolder = async ({ token, folderId }) => {
    try {
      setLoading(true);
      const folderIdFilter = folderId && folderId > 0 ? folderId : "Null";
      setFolderId(folderIdFilter === "Null" ? -1 : folderId);
      const searchFilter = searchText;

      const response = await get({
        token: token,
        url: "/api/dir/data",
        params: {
          page: 1,
          take: 1000,
          filter: `folder_id:=:${folderIdFilter};name:contains:${searchFilter}`,
          order: order.length === 0 ? "name" : order,
          order_method: orderMethod.length === 0 ? "ASC" : orderMethod,
        },
      });
      const { success, message, data, pagination } = response.data;
      if (success) {
        const { back_id, contents, current_path } = data;
        setBackFolderId(back_id);
        setCurrentPath(current_path);
        setListItem([...contents]);
        setListItemSource([...contents]);
        setSearchText("");
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR LOAD", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Memuat Folder");
    }
    setLoading(false);
  };

  const saveFile = async ({ token, file }) => {
    try {
      setLoading(true);

      const body = { file: file };
      if (folderId > 0) {
        body["folder_id"] = folderId;
      }
      console.log("BODY", body);
      const response = await post({
        isForm: true,
        token: token,
        url: "/api/file/addfile",
        body,
      });
      const { success, data } = response.data;
      if (success) {
        const { id } = data;
        setSelectedId(id);
        setSelectedType("file");
        setSelectedElement(data);
        setClipboard({ id: -1, type: "", name: "" });
        loadFolder({ token: tokenFileManager, folderId });
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR SAVE", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Mengunggah File");
    }
    setLoading(false);
  };

  const renameFile = async ({ token, id, name }) => {
    try {
      setLoading(true);

      const body = { name: name };
      if (folderId > 0) {
        body["folder_id"] = folderId;
      }
      if (id && id !== null && id > 0) {
        body["id"] = id;
      }
      const response = await post({
        isForm: true,
        token: token,
        url: "/api/file/renamefile",
        body,
      });
      const { success, data } = response.data;
      if (success) {
        const { id } = data;
        setSelectedId(id);
        setSelectedType("file");
        setSelectedElement(data);
        setClipboard({ id: -1, type: "", name: "" });
        loadFolder({ token: tokenFileManager, folderId });
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR SAVE", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Merename File");
    }
    setLoading(false);
  };

  const deleteFile = async ({ token, id }) => {
    try {
      setLoading(true);

      const body = { data: [id] };
      const response = await del({
        token: token,
        url: "/api/file/delete",
        body,
      });
      const { success, data } = response.data;
      if (success) {
        setSelectedId(-1);
        setSelectedType("");
        setSelectedElement(null);
        loadFolder({ token: tokenFileManager, folderId });
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR SAVE", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Menghapus File");
    }
    setLoading(false);
  };

  const saveFolder = async ({ token, id, name }) => {
    try {
      setLoading(true);

      const body = {};
      if (name && name.length > 0) {
        body["name"] = name;
      }
      if (folderId > 0) {
        body["folder_id"] = folderId;
      }
      if (id && id !== null && id > 0) {
        body["id"] = id;
      }
      const response = await post({
        isForm: true,
        token: token,
        url: "/api/folder/save",
        body,
      });
      const { success, data } = response.data;
      if (success) {
        const { id } = data;
        setSelectedId(id);
        setSelectedType("folder");
        setSelectedElement(data);
        setClipboard({ id: -1, type: "", name: "" });
        loadFolder({ token: tokenFileManager, folderId });
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR SAVE", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Menyimpan Folder");
    }
    setLoading(false);
  };

  const deleteFolder = async ({ token, id }) => {
    try {
      setLoading(true);

      const body = { data: [id] };
      const response = await del({
        token: token,
        url: "/api/folder/delete",
        body,
      });
      const { success, data } = response.data;
      if (success) {
        setSelectedId(-1);
        setSelectedType("");
        setSelectedElement(null);
        loadFolder({ token: tokenFileManager, folderId });
      }
    } catch (error) {
      const errorResponse = error.response;
      console.log("ERROR SAVE", errorResponse);
      uiContext.showErrorMsg("Error", "Gagal Menghapus Folder");
    }
    setLoading(false);
  };

  const filter = (event) => {
    const newText = event.target.value;
    setSearchText(newText);

    if (!newText || newText.length === 0) {
      setListItem([...listItemSource]);
    } else {
      const newList = listItemSource.filter((el) =>
        el.name.toLowerCase().includes(newText.toLowerCase())
      );
      setListItem(newList);
    }
  };

  const back = () => {
    loadFolder({ token: tokenFileManager, folderId: backFolderId });
  };

  const upload = (event) => {
    const file = event.files[0];
    saveFile({ token: tokenFileManager, file });
    fileUploadRef.current.clear();
  };

  const newFolder = (event) => {
    setDialogInputTextNewFolderVisible(true);
  };

  const newFolderAction = (event, value) => {
    saveFolder({ token: tokenFileManager, id: null, name: value });
  };

  const rename = (event) => {
    if (selectedId && selectedId !== null && selectedId > 0) {
      setDialogInputTextRenameVisible(true);
    }
  };

  const renameAction = (event, value) => {
    if (selectedElement.type === "file") {
      renameFile({ token: tokenFileManager, id: selectedId, name: value });
    } else if (selectedElement.type === "folder") {
      saveFolder({ token: tokenFileManager, id: selectedId, name: value });
    }
  };

  const cut = (event) => {
    setClipboard({
      id: selectedId,
      type: selectedType,
      name: selectedElement.name,
    });
  };

  const paste = (event) => {
    if (clipboard.type !== "" && clipboard.id > 0) {
      if (clipboard.type === "file") {
        renameFile({
          token: tokenFileManager,
          id: clipboard.id,
          name: clipboard.name,
        });
      } else if (clipboard.type === "folder") {
        saveFolder({
          token: tokenFileManager,
          id: clipboard.id,
          name: clipboard.name,
        });
      }
    }
  };

  const remove = (event) => {
    const type = selectedElement.type === "folder" ? "Folder" : "File";

    const accept = () => {
      removeAction();
    };

    const reject = () => {};

    confirmDialog({
      message: `Hapus ${type} terseleksi, lanjutkan ?`,
      header: "Konfirmasi Hapus",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Hapus",
      rejectLabel: "Batal",
      accept,
      reject,
    });
  };

  const removeAction = (event) => {
    if (selectedElement.type === "file") {
      deleteFile({ token: tokenFileManager, id: selectedId });
    } else if (selectedElement.type === "folder") {
      deleteFolder({ token: tokenFileManager, id: selectedId });
    }
  };

  const onDrop = (item) => {
    if (item) {
      const files = item.files;
      if (files && files.length > 0) {
        const file = files[0];
        saveFile({ token: tokenFileManager, file });
      }
    }
  };

  const contextMenuItems = [
    { label: "New Folder", icon: "pi pi-fw pi-plus", command: newFolder },
    {
      label: "Rename",
      icon: "pi pi-fw pi-pencil",
      command: rename,
      disabled: !selectedId || selectedId === null || selectedId <= 0,
    },
    { separator: true },
    {
      label: "Cut",
      icon: "pi pi-fw pi-download",
      command: cut,
      disabled: !selectedId || selectedId === null || selectedId <= 0,
    },
    {
      label: "Paste",
      icon: "pi pi-fw pi-clone",
      command: paste,
      disabled: clipboard.type === "" || clipboard.id <= 0,
    },
    { separator: true },
    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: remove,
      disabled: !selectedId || selectedId === null || selectedId <= 0,
    },
  ];

  const width = props.width ?? "100px";
  const height = props.height ?? "100px";

  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (onDrop) {
          onDrop(item);
        }
      },
      canDrop(item) {
        return true;
      },
      hover(item) {},
      collect: (monitor) => {
        const item = monitor.getItem();
        if (item) {
        }
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [folderId]
  );

  const isActive = canDrop && isOver;
  useEffect(() => {
    if (isActive) {
      setShowDropableEffect(true);
    } else {
      setShowDropableEffect(false);
    }
  }, [isActive]);

  const [lastTap, setLastTap] = useState({ time: 0, id: null });

  const generateDialogContent = () => {
    if (loading) {
      return (
        <div
          className={`${classes.overlay} col-center-center w-100 h-100 gap-3`}
        >
          <ProgressSpinner />
          <h3> Loading data ... </h3>
        </div>
      );
    } else {
      return (
        <div style={{ position: "relative" }}>
          <div className={`row-start-start wrap gap-2`}>
            <ContextMenu
              global
              model={contextMenuItems}
              ref={cm}
              breakpoint="767px"
            />
            {listItem.map((element) => {
              return (
                <ZirvuFileManagerInputItem
                  opacity={
                    clipboard.type === element.type &&
                    clipboard.id === element.id
                      ? 0.3
                      : 1
                  }
                  key={`${element.type}-${element.id}`}
                  {...element}
                  selected={
                    element.id === selectedId && element.type === selectedType
                  }
                  onRightClick={(event) => {
                    event.preventDefault();
                    setSelectedId(element.id);
                    setSelectedType(element.type);
                    setSelectedElement(element);
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    const now = Date.now();

                    // Detect double tap (within 300ms on same element)
                    if (lastTap.id === element.id && now - lastTap.time < 300) {
                      // Double tap detected
                      if (element.type === "folder") {
                        loadFolder({
                          token: tokenFileManager,
                          folderId: element.id,
                        });
                      } else {
                        props.onSelect(event, element);
                        setValue(element.url);
                        setDialogVisible(false);
                      }
                      setLastTap({ time: 0, id: null }); // reset
                    } else {
                      // Single tap: select item
                      setSelectedId(element.id);
                      setSelectedType(element.type);
                      setSelectedElement(element);
                      setLastTap({ time: now, id: element.id });
                    }
                  }}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  // ============================
  // Direct Camera + Compress + Upload to /api/file/addfilespecial
  // Used when props.directPhoto is set (see genElZirvuImage)
  // ============================

  const dataURLToFile = (dataUrl, fileName) => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], fileName, { type: mime });
  };

  const compressImage = async (
    file,
    { maxW = 1600, maxH = 1600, quality = 0.7 } = {}
  ) => {
    // return original if not an image
    if (!file.type.startsWith("image/")) return file;

    const img = document.createElement("img");
    const reader = new FileReader();
    const loadPromise = new Promise((resolve, reject) => {
      reader.onload = () => {
        img.onload = () => resolve();
        img.onerror = reject;
        img.src = reader.result;
      };
      reader.onerror = reject;
    });
    reader.readAsDataURL(file);
    await loadPromise;

    // Compute target size keeping aspect ratio
    let { width, height } = img;
    const ratio = Math.min(maxW / width, maxH / height, 1); // never upscale
    const targetW = Math.round(width * ratio);
    const targetH = Math.round(height * ratio);

    const canvas = document.createElement("canvas");
    canvas.width = targetW;
    canvas.height = targetH;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, targetW, targetH);

    const dataUrl = canvas.toDataURL("image/jpeg", quality);
    const compressed = dataURLToFile(dataUrl, `photo_${Date.now()}.jpg`);
    return compressed;
  };

  const savePhotoSpecial = async ({ token, file, folderName }) => {
    try {
      setLoading(true);
      const body = {
        folder_name: folderName || "", // server can decide default if empty
        file, // compressed image file
      };
      const response = await post({
        isForm: true,
        token,
        url: "/api/file/addfilespecial",
        body,
      });
      const { success, data } = response.data || {};
      if (success) {
        // Try to mirror existing selection behavior
        setSelectedId(data?.id ?? -1);
        setSelectedType("file");
        setSelectedElement(data ?? {});
        setClipboard({ id: -1, type: "", name: "" });

        // Prefer returned URL if provided
        if (data?.url) {
          setValue(data.url);
          // bubble up to parent if it expects onSelect signature
          if (typeof props.onSelect === "function") {
            props.onSelect(null, data);
          }
        }
      }
    } catch (error) {
      console.log("ERROR SAVE SPECIAL", error?.response || error);
      uiContext.showErrorMsg("Error", "Gagal Mengunggah Foto");
    }
    setLoading(false);
  };

  const handleDirectPhotoPick = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    try {
      const compressed = await compressImage(file, {
        maxW: props.maxPhotoWidth || 1600,
        maxH: props.maxPhotoHeight || 1600,
        quality: props.photoQuality ?? 0.75,
      });
      await savePhotoSpecial({
        token: tokenFileManager,
        file: compressed,
        folderName: props.folderName,
      });
      // reset input so subsequent capture triggers change
      if (cameraInputRef.current) cameraInputRef.current.value = "";
    } catch (err) {
      console.log("DIRECT PHOTO ERROR", err);
      uiContext.showErrorMsg("Error", "Gagal Memproses Foto");
    }
  };

  const openCamera = () => {
    if (cameraInputRef.current) {
      cameraInputRef.current.click();
    }
  };
  // ============================

  return (
    <div
      className={`${classes.wrapper} ${props.className} row-center-center`}
      style={{ width: width, height: height }}
    >
      <Dialog
        visible={dialogVisible}
        style={{
          width: isMobile ? "95vw" : "50rem",
          height: isMobile ? "75vh" : "44rem",
          maxWidth: isMobile ? "95vw" : undefined,
          maxHeight: isMobile ? "75vh" : undefined,
          padding: isMobile ? "1rem" : undefined,
        }}
        header={`/${currentPath}`}
        modal
        className={`p-fluid`}
        // footer={dialogFooter}
        onHide={(e) => setDialogVisible(false)}
      >
        <div
          className={`col-start-start w-100 gap-4 h-100`}
          style={{ padding: isMobile ? "0.5rem" : "1rem" }}
        >
          {/* Header: On mobile stack buttons vertically */}
          <div
            className={`${
              isMobile ? "col-start-stretch gap-3" : "row-between-center"
            } w-100`}
            style={{ gap: isMobile ? "1rem" : undefined }}
          >
            <div
              className={
                isMobile ? "col-start-stretch gap-2" : "row-start-center gap-3"
              }
            >
              <Button
                icon="pi pi-arrow-left"
                label={"Up a folder"}
                text
                onClick={(event) => {
                  back();
                }}
                style={{ width: isMobile ? "100%" : "120px" }}
              />
              <FileUpload
                ref={fileUploadRef}
                auto
                mode="basic"
                name="file[]"
                accept="*/*"
                chooseOptions={{
                  label: "Upload File",
                  icon: "pi pi-upload",
                  style: { width: isMobile ? "100%" : undefined },
                }}
                maxFileSize={1000000}
                customUpload
                uploadHandler={(event) => upload(event)}
              />
            </div>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                width: isMobile ? "100%" : "12rem",
                flexGrow: isMobile ? 1 : 0,
                gap: "0.5rem",
                border: "1px solid var(--surface-d)",
                borderRadius: "4px",
                padding: "0 0.5rem",
                backgroundColor: "var(--surface-a)",
              }}
            >
              <i
                className="pi pi-search"
                style={{
                  color: "var(--text-secondary-color, #aaa)",
                  fontSize: "1.2rem",
                  pointerEvents: "none",
                }}
              />
              <InputText
                placeholder="Search"
                value={searchText}
                onChange={filter}
                style={{
                  flexGrow: 1,
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  backgroundColor: "transparent",
                }}
              />
            </span>
          </div>
          <div
            className={`${classes.dialogContent} row-start-start w-100 h-100 p-3`}
            onContextMenu={(e) => {
              cm.current && cm.current.show(e);
            }}
            ref={drop}
            style={{
              overflowY: "auto",
              border: "1px solid var(--surface-d)",
              borderRadius: "6px",
              backgroundColor: "var(--surface-a)",
              padding: "1rem",
            }}
          >
            {generateDialogContent()}
            {showDropableEffect && (
              <div
                className="col-center-center w-100 h-100 gap-3"
                style={{
                  backgroundColor: "#cce8ffDD",
                  zIndex: 100,
                  top: 0,
                  left: 0,
                  position: "absolute",
                  borderRadius: "var(--border-radius-0)",
                }}
              >
                <i
                  className="pi pi-image mt-1 p-4"
                  style={{
                    fontSize: "7em",
                    borderRadius: "50%",
                    backgroundColor: "var(--surface-b)",
                    color: "#cce8ff",
                  }}
                ></i>
                <h3>Drop your image here</h3>
              </div>
            )}
          </div>
        </div>
      </Dialog>

      <ZirvuFileManagerDialogInputText
        title={"New Folder"}
        value={""}
        prompt={"Nama Folder Baru"}
        visible={dialogInputTextNewFolderVisible}
        onConfirm={(e, newValue) => {
          newFolderAction(e, newValue);
          setDialogInputTextNewFolderVisible(false);
        }}
        onHide={(e) => setDialogInputTextNewFolderVisible(false)}
      />

      <ZirvuFileManagerDialogInputText
        title={
          selectedElement && selectedElement.type === "file"
            ? "Rename File"
            : "Rename Folder"
        }
        value={selectedElement ? selectedElement.name : ""}
        prompt={
          selectedElement && selectedElement.type === "file"
            ? "Nama File Baru"
            : "Nama Folder Baru"
        }
        visible={dialogInputTextRenameVisible}
        onConfirm={(e, newValue) => {
          renameAction(e, newValue);
          setDialogInputTextRenameVisible(false);
        }}
        onHide={(e) => setDialogInputTextRenameVisible(false)}
      />

      <div
        className={`col-center-center ${classes.inputContainer}`}
        onClick={() => {
          if (props.disabled) return;
          // if directPhoto, open camera instead of the file manager dialog
          if (props.directPhoto) {
            openCamera();
          } else {
            setDialogVisible(true);
          }
        }}
        style={{
          cursor: props.disabled ? "default" : "pointer",
          padding: isMobile ? "0.5rem" : "1rem",
          gap: "1rem",
          maxWidth: isMobile ? "90vw" : "auto",
        }}
      >
        {value && (
          <img
            width={width}
            src={value}
            alt="Preview"
            style={{
              padding: "5px",
              width: isMobile ? "100%" : "auto",
              maxWidth: "350px",
              height: "auto",
              maxHeight: isMobile ? "200px" : "100%",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              objectFit: "contain",
            }}
          />
        )}
        <Button
          icon="pi p-fw pi-search"
          className={`${
            value && value.length > 0
              ? classes.inputContainerButtonFilled
              : classes.inputContainerButton
          }`}
          style={{ maxWidth: "140px" }}
          label={props.directPhoto ? "Take Photo" : "Browse"}
          outlined={!(value && value.length > 0)}
          disabled={props.disabled}
          onClick={(e) => {
            if (props.disabled) return;
            // prevent parent onClick duplication
            e.stopPropagation();
            if (props.directPhoto) {
              openCamera();
            } else {
              setDialogVisible(true);
            }
          }}
        />
      </div>

      {/* hidden input to trigger the camera, used when props.directPhoto is set */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={handleDirectPhotoPick}
      />
    </div>
  );
};

export default ZirvuFileManagerInput;
